import { useCallback } from 'react';
import { NavLink } from 'react-router-dom';
import { useSelector } from 'react-redux';

import Box from '@mui/material/Box';
import List from '@mui/material/List';
import Divider from '@mui/material/Divider';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';

import { selectIsUserAdmin, selectUserRoles } from '@store/auth';

import { verifyUserAccess } from '../../../../utils/utils';

function SidePanel({ menu, drawerSize = '250px', onItemClick = () => {} }) {
  const userRoles = useSelector(selectUserRoles);
  const isAdminUser = useSelector(selectIsUserAdmin);

  const checkUserAccess = useCallback(
    (featureRoles) => isAdminUser || verifyUserAccess(userRoles, featureRoles),
    [isAdminUser, userRoles],
  );

  return (
    <Box
      sx={{ width: drawerSize }}
      role="presentation"
      onClick={onItemClick(false)}
      onKeyDown={onItemClick(false)}>
      <List>
        {menu.map(
          ({
            title,
            path,
            icon,
            disabled = false,
            divider = false,
            roles = [],
          }) => {
            if (divider) return <Divider key={title} />;

            const hasAccess = checkUserAccess(roles);

            return (
              hasAccess && (
                <NavLink
                  style={{
                    textDecoration: 'none',
                  }}
                  key={title}
                  to={`${path}`}>
                  <ListItemButton
                    disabled={disabled}
                    style={{
                      textDecoration: 'none',
                      color: 'black',
                      alignItems: 'center',
                    }}>
                    <ListItemIcon sx={{}}>
                      {typeof icon === 'object' && icon}
                    </ListItemIcon>
                    <ListItemText
                      primaryTypographyProps={{
                        style: {
                          color: '#00000099',
                          fontSize: '14px',
                        },
                      }}
                      primary={title}
                    />
                  </ListItemButton>
                </NavLink>
              )
            );
          },
        )}
      </List>
    </Box>
  );
}

export default SidePanel;
